import { App } from "@capacitor/app";
import { Device } from "@capacitor/device";
import { Geolocation } from "@capacitor/geolocation";
import { isNative } from ".";
import { isSS4 } from "../env";
import { getVIN as getSS3VIN } from "./carPlugin";
import { getVIN as getSS4VIN } from "./carDiagPlugin";

export const getCurrentLocation = async () => {
  let locationInfo: any = null;
  try {
    await Geolocation.checkPermissions();
    await Geolocation.requestPermissions();

    locationInfo = await Geolocation.getCurrentPosition({
      enableHighAccuracy: true,
    });
  } catch (error) {
    console.log("Geolocation 获取位置信息失败:", error);
    try {
      locationInfo = await new Promise((resolve, reject) => {
        if (!window.navigator?.geolocation) {
          console.error("navigator.geolocation 该设备不支持地理位置API");
          reject(new Error("navigator.geolocation API not supported"));
          return;
        }

        const options = {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        };

        window.navigator.geolocation.getCurrentPosition(
          (position) => {
            console.log(
              "[BOWEN_LOG] 🚀 ~~ navigator.geolocation getAppInfo ~~ position:",
              position
            );
            resolve(position);
          },
          (error) => {
            reject(error);
          },
          options
        );
      });
    } catch (error) {
      console.log("navigator.geolocation 获取位置信息失败:", error);
    }
  }
  return locationInfo;
};

export const getVIN = async () => {
  let vin: string | null = null;

  if (!isNative) {
    vin = "web";
  }

  try {
    if (isSS4 && isNative) {
      vin = await getSS4VIN();
    } else {
      vin = await getSS3VIN();
    }
  } catch (error) {
    console.log("getAppInfo getVIN 获取失败:", error);
  }

  return vin;
};

export const getAppInfo = async () => {
  (window as any).__COMMIT_HASH__ = __COMMIT_HASH__;
  const commitHash = (window as any).__COMMIT_HASH__;
  const deviceInfo = await Device.getInfo();
  const deviceId = await Device.getId();
  const appInfo = await App.getInfo();

  // 获取更多设备信息
  const batteryInfo = await Device.getBatteryInfo();
  const languageCode = await Device.getLanguageCode();
  const locationInfo = await getCurrentLocation();
  const vin = await getVIN();
  console.log("[BOWEN_LOG] 🚀 ~~ getAppInfo ~~ vin:", vin);

  const info = {
    deviceModel: deviceInfo.model,
    devicePlatform: deviceInfo.platform,
    deviceManufacturer: deviceInfo.manufacturer,
    deviceId: deviceId.identifier,
    appVersion: appInfo.version,
    appBuild: appInfo.build,
    appName: appInfo.name,
    appId: appInfo.id,
    commitHash: commitHash,

    // 添加更多设备信息
    deviceOsVersion: deviceInfo.osVersion,
    deviceWebViewVersion: deviceInfo.webViewVersion,
    deviceIsVirtual: deviceInfo.isVirtual,
    deviceMemUsed: deviceInfo.memUsed,
    deviceRealDiskFree: deviceInfo.realDiskFree,
    deviceRealDiskTotal: deviceInfo.realDiskTotal,
    batteryLevel: batteryInfo.batteryLevel,
    isCharging: batteryInfo.isCharging,
    languageCode: languageCode.value,

    // 地理位置信息
    latitude: locationInfo?.coords?.latitude,
    longitude: locationInfo?.coords?.longitude,
    altitude: locationInfo?.coords?.altitude,
    accuracy: locationInfo?.coords?.accuracy,
    altitudeAccuracy: locationInfo?.coords?.altitudeAccuracy,
    speed: locationInfo?.coords?.speed,
    heading: locationInfo?.coords?.heading,
    timestamp: locationInfo?.timestamp,

    // 车辆数据
    vin: vin,
  };
  console.log("[BOWEN_LOG] 🚀 ~~ getAppInfo ~~ info:", info);
  return info;
};

// 监听 浏览器打开
App.addListener("appUrlOpen", async (event) => {
  console.log("appUrlOpen", event);
});
